var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 70,
    viewBox: "0 0 63 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-lion",
    transform: "translate(-6 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M48,5A37.731,37.731,0,0,0,37.5,6.744,37.731,37.731,0,0,0,27,5C21.692,5,6,6.454,6,24.181S16.5,48.594,16.5,48.594h42S69,41.908,69,24.181,53.308,5,48,5Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M26.254,19V60.85S7,49.845,7,36.438,15.752,19,15.752,19Zm21,0V60.85s19.254-11,19.254-24.412S57.761,19,57.761,19Z",
    transform: "translate(0.744 10.663)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M31.573,23.488,14.023,20c0,13.369-.769,22.561,3.51,31.387,3.784,7.809,14.04,12.206,14.04,12.206s10.256-4.4,14.04-12.206c4.279-8.829,3.51-18.018,3.51-31.387Z",
    transform: "translate(5.927 11.406)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M26.975,31C23.123,31,20,33.342,20,36.231s3.123,5.231,6.975,5.231,6.975-2.342,6.975-5.231S30.827,31,26.975,31Z",
    transform: "translate(10.525 19.529)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M46.048,15.744c1.931,0,3.163-1.744,5.257-1.744a4.878,4.878,0,0,1,5.257,5.231c0,4.607-7.01,8.719-7.01,8.719Zm-24.534,0c-1.931,0-3.163-1.744-5.257-1.744A4.878,4.878,0,0,0,11,19.231c0,4.607,7.01,8.719,7.01,8.719Z",
    transform: "translate(3.719 6.764)",
    fill: "#f57f17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M40.325,14c-6.118,0-8.775,3.487-8.775,3.487S28.893,14,22.775,14,14,23.338,14,26.206s7.02,13.95,7.02,13.95H42.08s7.02-11.082,7.02-13.95S46.443,14,40.325,14Z",
    transform: "translate(5.95 6.784)",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M21.147,17c6.147,0,6.147,8.719,6.147,8.719H22.171C15,25.719,15,17,15,17Zm19.319,0c-6.147,0-6.147,8.719-6.147,8.719h5.123c7.171,0,7.171-8.719,7.171-8.719Z",
    transform: "translate(6.694 9.011)",
    fill: "#5d4037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M20.487,17A3.488,3.488,0,1,1,17,20.487,3.489,3.489,0,0,1,20.487,17Zm17.437,0a3.488,3.488,0,1,0,3.487,3.487A3.489,3.489,0,0,0,37.925,17Z",
    transform: "translate(8.294 9.008)",
    fill: "#eeff41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M19.744,18A1.744,1.744,0,1,1,18,19.744,1.743,1.743,0,0,1,19.744,18Zm17.438,0a1.744,1.744,0,1,0,1.744,1.744A1.743,1.743,0,0,0,37.181,18Z",
    transform: "translate(9.037 9.754)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M49.1,26.206C49.1,23.338,47.491,14,40.325,14c-6.118,0-8.775,3.487-8.775,3.487S28.893,14,22.775,14C16.048,14,14,23.338,14,26.206c0-3.379,8.282-8.829,12.285-1.744,0,7.793-3.784,9.809-6.186,14.2a6.876,6.876,0,0,0-.834,3.233A7,7,0,0,0,31.55,46.469,7,7,0,0,0,43.835,41.9,6.876,6.876,0,0,0,43,38.667c-2.4-4.4-6.186-6.412-6.186-14.2C40.818,17.379,49.1,22.829,49.1,26.206Z",
    transform: "translate(5.95 6.806)",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M33.58,40.053a8.494,8.494,0,0,1-1.374.139,8.65,8.65,0,0,1-5.231-1.775,8.65,8.65,0,0,1-5.231,1.775,8.494,8.494,0,0,1-1.374-.139,4.029,4.029,0,0,1-.37-1.6c0-.082.026-.157.031-.237a6.753,6.753,0,0,0,6.944-2.169,6.753,6.753,0,0,0,6.944,2.169c.005.08.031.155.031.237A4.029,4.029,0,0,1,33.58,40.053ZM26.975,29.73c-3.852,0-6.975-3.852-6.975,0s6.975,3.487,6.975,6.975c0-3.487,6.975-3.123,6.975-6.975S30.827,29.73,26.975,29.73Z",
    transform: "translate(10.525 17.294)",
    fill: "#5d4037"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLion);
export default __webpack_public_path__ + "static/media/lion.306269e4620e5d8690b5bc8e984d12f8.svg";
export { ForwardRef as ReactComponent };